// The folder picker's "new folder" choice, shared by the DM page's map forms.
export const NEW_FOLDER_OPTION_VALUE = '__create_new_folder__';
